import { EQUIPMENT, FOCUS_AREA } from 'utils/constants/categories';

import { createSelector } from 'reselect';

// Redux Store
export const getSelectVideo = (state) => state.selectVideo;

export const getSelectVideoError = createSelector(
  getSelectVideo,
  ({ error }) => error
);
export const isVideoListLoading = createSelector(
  getSelectVideo,
  ({ loading }) => loading
);

export const getSelectVideoItems = createSelector(
  getSelectVideo,
  ({ items }) => items
);

// Form Values
export const getSelectVideoForm = (state) => state.form['select-video'];

export const getSelectVideoSearchTerm = createSelector(
  getSelectVideoForm,
  (selectVideoForm) => selectVideoForm?.values.search
);
export const getSelectVideoSearchEquipment = createSelector(
  getSelectVideoForm,
  (selectVideoForm) => selectVideoForm?.values[EQUIPMENT]
);
export const getSelectVideoSearchFocusArea = createSelector(
  getSelectVideoForm,
  (selectVideoForm) => selectVideoForm?.values[FOCUS_AREA]
);

export const getSelectVideoElement = createSelector(
  getSelectVideoForm,
  (selectVideoForm) => selectVideoForm?.values.videoElement
);

export const getOrder = createSelector(getSelectVideo, ({ order }) => order);

export const getSort = createSelector(getSelectVideo, ({ sort }) => sort);

export const getSkip = createSelector(getSelectVideo, ({ skip }) => skip);

export const getCount = createSelector(getSelectVideo, ({ count }) => count);
